// src/App.js

import React, { useState, useEffect } from "react";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import Sidebar from "./UI/Sidebar";
import GPT from "./UI/GPT";
import Loader from "./UI/Loader";
import Contact from "./UI/Contact";
import DeveloperPage from "./UI/Developer";
import Login from "./UI/Login";
import ProtectedRoute from "./ProtectedRoute";
import './App.css'
import Register from "./UI/Register";

const App = () => {
  const [loading, setLoading] = useState(true);
  const [sidebarOpen, setSidebarOpen] = useState(false);

  const toggleSidebar = () => {
    setSidebarOpen(!sidebarOpen);
  };

  useEffect(() => {
    setTimeout(() => {
      setLoading(false);
    }, 2000);
  }, []);

  return (
    <Router>
      {loading ? (
        <Loader />
      ) : (
        <div className="relative flex overflow-hidden bg-[#eeeeee] h-[100vh] w-full Body">
          <Sidebar isOpen={sidebarOpen} toggleSidebar={toggleSidebar} />
          <div className={`transition-transform transform w-full overflow-y-auto ${sidebarOpen ? 'lg:ml-64' : 'lg:ml-64'}`}>
            <Routes>
              <Route path="/login" element={<Login />} />
              <Route path="/signup" element={<Register />} />
              <Route path="/contact" element={<Contact />} />
              <Route path="/developer" element={<DeveloperPage />} />
              <Route
                path="/"
                element={
                  <ProtectedRoute>
                    <GPT />
                  </ProtectedRoute>
                }
              />
            </Routes>
          </div>
        </div>
      )}
    </Router>
  );
};

export default App;
